module.exports = __webpack_public_path__ + "public/img/anlitwo.6a79d1f8.gif";